module.exports = __webpack_public_path__ + "img/logo.16c33553.png";